<template>
  <div class="min-h-screen flex items-center justify-center">
    <slot />
  </div>
</template>